import { FormField, Input } from '@wix/design-system';
import { DataHooks } from '../../../../../constants/dataHooks';
import React, { useMemo } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useSingleTemplateData } from '../../../../../hooks/useSingleTemplateData';
import { isValidUrl } from '../../../../../utils/validators';
import { useSelfHostedContext } from '../SelfHostedModalContextProvider';
import { useTemplatesPageBi } from '../../../../../hooks/useTemplatesPageBi';

interface BaseUrlInputProps {
  isFormSubmitted: boolean;
}
export const BaseUrlInput = ({ isFormSubmitted }: BaseUrlInputProps) => {
  const { t } = useTranslation();
  const { formData, updateBaseUrl } = useSelfHostedContext();
  const { template } = useSingleTemplateData();
  const { reportInputFocused } = useTemplatesPageBi();
  const { baseUrl, selectedDeploymentProvider } = formData;
  const selectedProviderLowerCase = selectedDeploymentProvider?.toLowerCase();

  const urlInvalid = useMemo(() => {
    if (!baseUrl) {
      return t('app.template-page.modal.self-hosted.step2.base-url.missing');
    }
    if (!isValidUrl(baseUrl)) {
      return t('app.template-page.modal.self-hosted.step2.base-url.not-valid');
    }
    return false;
  }, [baseUrl, t]);
  return (
    <FormField
      required
      label={t(
        `app.template-page.modal.self-hosted.step2.base-url-${selectedProviderLowerCase}`,
      )}
    >
      <Input
        required
        onFocus={() =>
          reportInputFocused(template.id, 'use template - baseUrl')
        }
        dataHook={DataHooks.SelfHostModalBaseUrlInput}
        status={urlInvalid && isFormSubmitted ? 'error' : undefined}
        statusMessage={urlInvalid}
        value={baseUrl}
        onChange={(e) => updateBaseUrl(e.target.value)}
        placeholder={t(
          `app.template-page.modal.self-hosted.step2.app-name-placeholder-${selectedProviderLowerCase}`,
        )}
      />
    </FormField>
  );
};
